import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {getCountersImpl} from "../../backend/connectors/JavaConnector";
import i18next from "i18next";

export function MotivationBlock() {
    const {t} = useTranslation();
    const [ticketBalance, setTicketBalance] = useState(0);
    const [balanceMessage, setBalanceMessage] = useState("");
    const [ready, setReady] = useState(false);
    let ticketBalanceConfig = appdata.product["ticketBalance"]

    async function getCounters() {
        let cnt = await getCountersImpl()
        if (i18next.language !== "ru")
            setBalanceMessage("")
        else {
            setBalanceMessage("manyTickets")
            if (cnt === 1)
                setBalanceMessage("oneTicket")
            if (cnt >= 2 && cnt <= 4)
                setBalanceMessage("234Tickets")
        }
        setTicketBalance(cnt);
        setReady(true)

    }

    useEffect(() => {
        if (isCycledDynamicBalance())
            getCounters();

    }, [isCycledDynamicBalance, getCounters])

    function isCycledDynamicBalance() {
        if (ticketBalanceConfig === undefined) return false;
        return "cycledDynamicBalance" === ticketBalanceConfig["algorithm"];
    }

    return (
        <div>
            {(isCycledDynamicBalance() && ready) ?
                <h2 id="motivationText"
                    className="offer-pay__title red bigfont">{t("ThisConditionsBalance", {balance: ticketBalance})} {t(balanceMessage)}</h2>
                : <div></div>}
        </div>
    )
}


